import axios from 'axios'

const baseURL = '/api/region/'

export default class Region {
	/** @constructor
	 * @param {number | Object} init
	 * @property {string} name
	 */
	constructor (init = {}) {
		this.id = null
		this.setDefaultData()
		if (typeof init === 'number') {
			this.id = init
			this.getSingle().then()
		} else {
			this.setDefaultData(init)
		}
	}

	setDefaultData (init = {}) {
		if (!init) return

		this.id = init.hasOwnProperty('id') ? init.id : null
		this.name = init.hasOwnProperty('name') ? init.name : ''
		this.country_id = init.hasOwnProperty('country_id') ? init.country_id : null
	}

	static url = baseURL

	/**
	 * get all region
	 * @param {Object} params
	 * @returns {Promise<{data: City[]}>}
	 */
	static getAll (params) {
		return axios.get(baseURL, {
			params
		})
			.then(res => {
				return {
					...res.data,
					data: res.data.data.map(item => new Region(item))
				}
			})
			.catch(err => {
				console.error(err)
				return null
			})
	}
	/**
	 * get region by id
	 * @returns {Promise<void>}
	 */
	async getSingle () {
		try {
			const {data} = await axios.get(`${baseURL}${this.id}`)
			this.setDefaultData(data.data)
		} catch (e) {
			console.error(e)
		}
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/Region.class.js